module.exports = __webpack_public_path__ + "img/tedexis-light-medium.2c39b489.svg";